export default __webpack_public_path__ + "fda6ee6fc78b038cf7e4d48c324fd715.png";